/* eslint-disable @typescript-eslint/no-shadow */
import { Injectable } from '@angular/core';
import { ApiConfig } from './api.config';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class CancelarRequestService extends ApiConfig {
  constructor(private http: HttpClient) {
    super();
  }

  cancelRequest(processId: string): Promise<any> {
    const url = `https://project-5082f113-c983-477a-973.uw.r.appspot.com/Request/Cancelar?processId=${processId}`;

    return new Promise((resolve, reject) => {
      this.http.post(url, null).subscribe({
        next: (response) => resolve(response),
        error: (error) => reject(error),
      });
    });
  }
}
